module.exports = __webpack_public_path__ + "img/smart-plug.078f13f7.svg";